module.exports = __webpack_public_path__ + "static/eikenvloer-2-8781525bfa81216eea70ef53e739e5e2.jpg";